import AppStandardButton from "../../components/UI/AppButtons";
import { BookingInformationRow } from "../../components/Layouts/BookingInformation/BookingInformation";
import ThankYouHeader, {
  getThankYouIframeHeight,
} from "../../components/Layouts/ThankYouHeader/ThankYouHeader";
import React, { useEffect, useState } from "react";
import i18n, { t } from "i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { BookingApi } from "../../API/Apis/BookingApi";
import { NexiChargeTransactionDetails } from "../../@types/Booking/nexiTransactionDetails";
import BookingGetters from "../../store/onlineBooking/getters";
import { TextResource } from "../../@types/DTO/AppSetting";
import { formatTheme } from "../../config/MuiColorThemes";
import { createTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { BookingDetails } from "../../@types/Booking/bookingDetails";
import { CancelledPage } from "../nexiBookingCancelled";
import {
  trackPurchase,
  trackGoogleAdsConversion,
  readPurchaseItems,
  clearPurchaseItems,
} from "../../helpers/tracking";
import { useFireOnceWhenReady } from "../../hooks/useFireOnceWhenReady";

interface BookingConfirmPageProps {
  isScalapay?: boolean;
  isPaypal?: boolean;
  isDatatrans?: boolean;
}
export function BookingConfirmPage({
  isScalapay = false,
  isPaypal = false,
  isDatatrans = false,
}: BookingConfirmPageProps) {
  const isUserLoggedin = localStorage.getItem("isUserLoggedin");
  const appSettings = BookingGetters.getAppSettings();
  const trackingCurrency = BookingGetters.getCurrency();
  const redirectWebCheckIn = appSettings && appSettings?.redirectWebCheckIn;
  const HideOneButton =
    appSettings && appSettings?.hideButtonAtConfirmationPage;
  const hideHomeButtonFromNormalBooking =
    appSettings && appSettings?.hideHomeButtonFromNormalBooking;
  const hideHomeButtonFromReservedArea =
    appSettings && appSettings?.hideHomeButtonFromReservedArea;
  const showHomeButton =
    (isUserLoggedin !== "true" && !hideHomeButtonFromNormalBooking) ||
    (isUserLoggedin === "true" && !hideHomeButtonFromReservedArea);
  const bookingInformationFromRedux: BookingDetails =
    BookingGetters.getBookingDetails();
  const [bookingInformation, setBookingInformation] = useState<BookingDetails>(
    () => {
      const stored = sessionStorage.getItem("wireTransferBookingInfo");
      return stored ? JSON.parse(stored) : bookingInformationFromRedux;
    }
  );
  const scriptChannel = bookingInformation?.scriptChannel;
  const scriptChannelWindow = window.name;
  const scriptChannelSession = sessionStorage.getItem("scriptChannel");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const datatransRefno = searchParams.get("refno") || "";
  const datatransStatus = (searchParams.get("status") || "").toLowerCase();
  const isDatatransFailure =
    isDatatrans &&
    !(
      datatransRefno &&
      (datatransStatus === "settled" || datatransStatus === "authorized")
    );
  const datatransResId = isDatatrans
    ? datatransRefno.replace(/^DT/i, "").split("_")[0]
    : "";
  const [datatransDbId, setDatatransDbId] = useState("");
  const importo = searchParams.get("importo") || "";
  const price = Number(importo) / 100;
  // const currentPriceToPay = sessionStorage.getItem("currentPriceToPay");
  const rawPrice = sessionStorage.getItem("currentPriceToPay");
  const currentPriceToPay =
    rawPrice && !isNaN(Number(rawPrice))
      ? parseFloat(Number(rawPrice).toFixed(2))
      : null;
  const num_contratto = searchParams.get("codTrans") || "";
  const dbId =
    num_contratto.split("RES_")[1] ||
    datatransDbId ||
    sessionStorage.getItem("wireTransferDbId") ||
    "";
  const lang = i18n.language;
  const { t: translate } = useTranslation();
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];
  const textResourcesLoaded = !!textResource?.[lang];
  const congratsLogo =
    data.find((item) => item.key === "booking_congrats_logo")?.body || "";
  const congratsIcon =
    data.find((item) => item.key === "booking_congrats_icon")?.body || "";

  const [congratsText, setCongratsText] = useState({
    title: "",
    message: "",
    note: "",
  });
  const [showDiscoverThankText, setShowDiscoverThankText] =
    useState<String>("");
  const [discoverButtonText, setDiscoverButtonText] = useState<String>("");
  useEffect(() => {
    const discoverThankTextData = data.find(
      (item) => item.key === "showDiscoverExpThankYou"
    );
    const titleText = data.find(
      (item) => item.key === "booking_congrats_title"
    );
    const messageText = data.find(
      (item) => item.key === "booking_congrats_message"
    );
    const noteText = data.find((item) => item.key === "booking_congrats_note");
    setCongratsText({
      title: titleText?.body || t("booking_congrats_title"),
      message: messageText?.body || "",
      note: noteText?.body || t("booking_congrats_note"),
    });
    setShowDiscoverThankText(discoverThankTextData?.body || "");

    const discoverButtonTextData = data.find(
      (item) => item.key === "discoverButtonText"
    );
    setDiscoverButtonText(
      discoverButtonTextData?.body || t("Discover the experiences")
    );
  }, [lang, textResource, translate]);
  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const primaryColor = dynamicTheme?.palette["primary"]?.main;
  const secondaryColor = dynamicTheme?.palette["secondaryColor"]?.main;
  const confirmationTextColor =
    dynamicTheme?.palette["confirmationTextColor"]?.contrastText;
  const ResId = searchParams.get("num_contratto");
  const [vehicleCategory, setVehicleCategory] = useState("");
  const [vehicleName, setVehicleName] = useState("");
  const [pickupDate, setPickupDate] = useState("");
  console.log("NexiResId", ResId?.split("-")[2]);
  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: getThankYouIframeHeight(
            700,
            congratsLogo,
            congratsIcon
          ),
        },
      },
      "*"
    );
  }
  useEffect(() => {
    requestParentResize();
  }, [congratsLogo, congratsIcon]);
  const showResPrintButton = appSettings && appSettings?.showResPrintButton;
  const navigateTo = useNavigate();
  useEffect(() => {
    if (!isScalapay && !isPaypal && !isDatatrans) {
      const payStatus = searchParams.get("stato");
      if (searchParams.get("esito") != "OK") {
        navigateTo("/MovementRenewal/UrlBackRenew");
      } else if (
        searchParams.get("esito") == "OK" &&
        (payStatus == "Non Creato" ||
          payStatus == "Negato" ||
          payStatus == "Annullato" ||
          payStatus == "In Corso")
      ) {
        navigateTo("/MovementRenewal/UrlBackRenew");
      } else {
        const nexiPageRedirectionUrl: NexiChargeTransactionDetails = {
          amount: searchParams.get("importo") || "",
          mac: searchParams.get("mac") || "",
          codAut: searchParams.get("codAut") || "",
          api_key: searchParams.get("alias") || "",
          deviceId: searchParams.get("codAut") || "",
          data: searchParams.get("data") || "",
          orario: searchParams.get("orario") || "",
          regione: searchParams.get("regione") || "",
          nazionalita: searchParams.get("nazionalita") || "",
          tipoProdotto: searchParams.get("tipoProdotto") || "",
          ppo: searchParams.get("ppo") || "",
          codiceConvenzione: searchParams.get("codiceConvenzione") || "",
          brand: searchParams.get("brand") || "",
          tipoTransazione: searchParams.get("tipoTransazione") || "",
          pan: searchParams.get("pan") || "",
          num_contratto: searchParams.get("num_contratto") || "",
          scadenza_pan: searchParams.get("scadenza_pan") || "",
          codTrans: searchParams.get("codTrans") || "",
          tipo_servizio: searchParams.get("tipo_servizio") || "",
          alreadyChargedAndBilled: "false",
        };
        BookingApi.savePaymentForNexi(nexiPageRedirectionUrl).then((e) => {
          setVehicleCategory(e.data.vehicleCategory);
          setVehicleName(e.data.vehicleName);
          setPickupDate(e.data.dropoffDate);
          this.allReservationSources = e.data;
          return e.data;
        });
      }
    } else if (isScalapay) {
      if (
        searchParams.get("status") != "SUCCESS" ||
        !searchParams.get("orderToken")
      ) {
        navigateTo("/MovementRenewal/UrlNotDoneScalapay");
      } else if (
        searchParams.get("orderToken") &&
        searchParams.get("status") == "SUCCESS"
      ) {
        const orderToken = searchParams.get("orderToken");
        BookingApi.sendScalapayTransactionDetails(orderToken).then((e) => {
          setVehicleCategory(
            e?.data?.data?.ScalapayVehicleSummary?.vehicleCategory
          );
          setVehicleName(e?.data?.data?.ScalapayVehicleSummary?.vehicleName);
          setPickupDate(e?.data?.data?.ScalapayVehicleSummary?.dropoffDate);
          return e.data.ScalapayVehicleSummary;
        });
      }
    } else if (isPaypal) {
      if (searchParams.has("token") && searchParams.has("PayerID")) {
        const orderId = searchParams.get("token");
        BookingApi.sendPayPalTransactionDetails(orderId).then((e) => {
          setVehicleCategory(
            e?.data?.data?.paypalVehicleSummary?.vehicleCategory
          );
          setVehicleName(e?.data?.data?.paypalVehicleSummary?.vehicleName);
          setPickupDate(e?.data?.data?.paypalVehicleSummary?.dropoffDate);
          return e.data.paypalVehicleSummary;
        });
      } else {
        navigateTo("/MovementRenewal/UrlNotDonePayPal");
      }
    }
  }, []);

  useEffect(() => {
    if (!isDatatrans || isDatatransFailure || !datatransResId) return;
    let cancelled = false;
    BookingApi.getReservationNumber(datatransResId)
      .then((reservation) => {
        if (!cancelled && reservation?.prefix && reservation?.number != null) {
          setDatatransDbId(`${reservation.prefix}${reservation.number}`);
        }
      })
      .catch(() => {
        // lookup failure just leaves the reservation badge hidden
      });
    return () => {
      cancelled = true;
    };
  }, [isDatatrans, isDatatransFailure, datatransResId]);

  useEffect(() => {
    if (vehicleName && vehicleCategory && pickupDate) {
      if (process.env.REACT_APP_COMPANY_CODE === "viaggiare") {
        const checkOutDate = pickupDate || "";
        let formattedDate;
        if (checkOutDate) {
          console.log("checkout" + checkOutDate);
          const date = new Date(checkOutDate);
          formattedDate =
            date.getFullYear() +
            "-" +
            String(date.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(date.getDate()).padStart(2, "0");
        }

        const tempResId = searchParams.get("codTrans");
        const orderRef = tempResId
          ? tempResId.split("_").slice(3).join(" ")
          : "";

        console.log("tempResId");
        console.log(orderRef);

        const currencyCode = appSettings?.defaultCurrency || "EUR";
        const script1 = document.createElement("script");
        script1.type = "text/javascript";
        script1.innerHTML = `
      var orderRef = '${orderRef} ${vehicleName}';
      var payoutCodes = '';
      var offlineCode = '';
      var uid = '${vehicleCategory}';
      var htname = '';
      var merchantID = 4918;
      var pixel = 0;
      var orderValue = ${searchParams.get("importo")};
      var checkOutDate = '${formattedDate}';
      var currencyCode = '${currencyCode}';
    `;
        document.body.appendChild(script1);

        const script2 = document.createElement("script");
        script2.type = "text/javascript";
        script2.src =
          "https://scripts.affilired.com/v2/confirmation.php?merid=4918";

        script2.onload = () => {
          const script3 = document.createElement("script");
          script3.type = "text/javascript";
          script3.innerHTML = `
        recV3(orderValue, orderRef, merchantID, uid, htname, pixel, payoutCodes, offlineCode, checkOutDate, currencyCode);
      `;
          document.body.appendChild(script3);
        };

        document.body.appendChild(script2);

        return () => {
          if (script1 && document.body.contains(script1)) {
            document.body.removeChild(script1);
          }
          if (script2 && document.body.contains(script2)) {
            document.body.removeChild(script2);
          }
        };
      }
    }
  }, [vehicleCategory, vehicleName, pickupDate]);

  useFireOnceWhenReady(
    dbId && appSettings,
    () => {
      const gateway = isScalapay ? "SCALAPAY" : isPaypal ? "PAYPAL" : "NEXI";
      const stored = readPurchaseItems();
      trackPurchase({
        transactionId: dbId,
        value: price,
        currency: stored?.currency || trackingCurrency || "EUR",
        items: stored?.items || [],
        coupon: stored?.coupon,
        paymentType: stored?.paymentType || gateway,
      });
      trackGoogleAdsConversion({
        enableDataLayer: appSettings?.enableDataLayer,
        event: appSettings?.gtagManagerEvent,
        sendTo: appSettings?.gTagManagerSendTo,
        currency: appSettings?.gTagManagerCurrency,
        value: appSettings?.enableGtagManagerValue ? price : null,
        transactionId: appSettings?.enableGTagManagerTranscationId
          ? dbId
          : null,
      });
      clearPurchaseItems();
    },
    [dbId, appSettings]
  );
  const secondPageBackgroundColor =
    appSettings && appSettings["secondPageBackgroundColor"];

  const isAffiliateEnable = appSettings && appSettings?.enableAffiliate;
  // const scriptAffiliate = bookingInformation?.affiliateDetails?.code;
  const scriptAffiliateSession = sessionStorage.getItem("scriptAffiliate");

  const isVoucherCodeEnable = appSettings && appSettings?.showWebCodeInput;
  const scriptVoucherCodeSession = sessionStorage.getItem("scriptVoucherCode");

  const currencySymbol =
    appSettings?.defaultCurrency === "USD"
      ? "$"
      : appSettings?.defaultCurrency === "GBP"
      ? "£"
      : "€";

  const formatBookingDate = (dateVal: number | Date | undefined): string => {
    if (!dateVal) return "";
    const d = new Date(dateVal);
    if (isNaN(d.getTime())) return "";
    const locale =
      lang === "it"
        ? "it-IT"
        : lang === "fr"
        ? "fr-FR"
        : lang === "es"
        ? "es-ES"
        : "en-US";
    return d.toLocaleString(locale, {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const homepageHref =
    scriptChannelWindow || scriptChannel
      ? `/embed?scriptChannel=${
          scriptChannelSession || scriptChannelWindow || scriptChannel
        }`
      : isAffiliateEnable && scriptAffiliateSession
      ? `/embed?scriptAffiliate=${scriptAffiliateSession}`
      : isVoucherCodeEnable && scriptVoucherCodeSession
      ? `/embed?scriptVoucherCode=${scriptVoucherCodeSession}`
      : "/embed";

  const showWebCheckin = appSettings?.showNewWebCheckin;
  const webCheckinHref = `/booking/web-check-in-new?lang=${i18n.language}`;

  if (isDatatransFailure) {
    return <CancelledPage />;
  }

  return (
    <section
      className="min-h-screen flex flex-col items-center justify-center py-10 px-4"
      style={{
        background: secondPageBackgroundColor || "#f0f2f5",
      }}
    >
      <div
        className="bg-white rounded-2xl shadow-lg w-full overflow-hidden px-8"
        style={{
          maxWidth: "480px",
          borderTop: `4px solid ${secondaryColor || "#E3007B"}`,
        }}
      >
        {/* Success header */}
        <ThankYouHeader
          title={congratsText?.title || t("booking_congrats_title")}
          message={congratsText?.message}
          note={congratsText?.note}
          logoUrl={congratsLogo}
          icon={congratsIcon}
          ready={textResourcesLoaded}
          primaryColor={primaryColor}
        >
          {dbId && (
            <div
              className="mt-5 px-8 py-1.5 rounded-md border-2 font-bold text-lg"
              style={{
                borderColor: primaryColor || "#22c55e",
                color: primaryColor || "#22c55e",
              }}
            >
              {dbId?.replace(/^([A-Za-z]+)(\d+)$/, "$1-$2")}
            </div>
          )}
        </ThankYouHeader>

        <hr className="border-gray-200" />

        {/* Itinerary */}
        <div className="py-5">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "20px 1fr",
              gap: "0 16px",
            }}
          >
            {/* Pick-up row */}
            <div className="flex flex-col items-center">
              <div
                className="w-3 h-3 rounded-full mt-1 flex-shrink-0"
                style={{ backgroundColor: primaryColor || "#28B330" }}
              />
              <div className="w-px bg-gray-300 mt-1 flex-1" />
            </div>
            <div className="pb-5">
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-0.5">
                {t("Pick-up")}
              </p>
              <p className="text-sm font-semibold text-gray-900">
                {[
                  bookingInformation?.pickUpLocationDetails?.code,
                  bookingInformation?.pickUpLocationName,
                ]
                  .filter(Boolean)
                  .join(" - ")}
              </p>
              <p className="text-sm text-gray-500">
                {formatBookingDate(bookingInformation?.pickUpDateAndTime)}
              </p>
            </div>
            {/* Drop-off row */}
            <div className="flex justify-center pt-1">
              <div
                className="w-3 h-3 rounded-full flex-shrink-0"
                style={{ backgroundColor: secondaryColor || "#E3007B" }}
              />
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-0.5">
                {t("Drop-off")}
              </p>
              <p className="text-sm font-semibold text-gray-900">
                {[
                  bookingInformation?.dropOffLocationDetails?.code,
                  bookingInformation?.dropOffLocationName,
                ]
                  .filter(Boolean)
                  .join(" - ")}
              </p>
              <p className="text-sm text-gray-500">
                {formatBookingDate(bookingInformation?.dropOffDateAndTime)}
              </p>
            </div>
          </div>
        </div>

        <hr className="border-gray-200" />

        {/* Total amount */}
        {currentPriceToPay && (
          <div className="flex justify-between items-center py-4">
            <span className="text-sm text-gray-600">
              {t("Total rental amount")}
            </span>
            <span className="text-xl font-bold text-gray-900">
              {currencySymbol}
              {currentPriceToPay}
            </span>
          </div>
        )}

        {/* Scalapay extra button */}
        {isScalapay && appSettings?.customerWebsiteURL && (
          <div className="pb-4">
            <AppStandardButton
              href={appSettings.customerWebsiteURL}
              variant="contained"
              className="w-full py-4"
              style={{
                backgroundColor: primaryColor || "#22c55e",
                borderRadius: "10px",
                textTransform: "none",
                border: "none",
                width: "100%",
              }}
            >
              <span className="normal-case font-semibold text-sm text-white">
                {translate("Visit Website")}
              </span>
            </AppStandardButton>
          </div>
        )}

        {/* Action buttons */}
        <div className="flex gap-3 pb-8">
          {showHomeButton && (
            <AppStandardButton
              href={homepageHref}
              variant="contained"
              className="flex-1 py-4"
              style={{
                backgroundColor: primaryColor || "#22c55e",
                borderRadius: "10px",
                textTransform: "none",
                border: "none",
              }}
            >
              <span className="normal-case font-semibold text-sm text-white">
                Homepage
              </span>
            </AppStandardButton>
          )}
          {!redirectWebCheckIn
            ? !HideOneButton && (
                <AppStandardButton
                  href={showWebCheckin ? webCheckinHref : homepageHref}
                  variant="outlined"
                  className="flex-1 py-4"
                  style={{
                    borderRadius: "10px",
                    borderColor: secondaryColor || "#E3007B",
                    backgroundColor: "#fff0f5",
                    textTransform: "none",
                  }}
                >
                  <span
                    className="normal-case font-semibold text-sm"
                    style={{ color: secondaryColor || "#E3007B" }}
                  >
                    {showWebCheckin ? "Web Check-in" : "Dashboard"}
                  </span>
                </AppStandardButton>
              )
            : isUserLoggedin == "true" &&
              appSettings?.showWebCheckReservArea &&
              !HideOneButton && (
                <AppStandardButton
                  href={`/booking/web-check-in?lang=${i18n.language}`}
                  variant="outlined"
                  className="flex-1 py-4"
                  style={{
                    borderRadius: "10px",
                    borderColor: secondaryColor || "#E3007B",
                    backgroundColor: "#fff0f5",
                    textTransform: "none",
                  }}
                >
                  <span
                    className="normal-case font-semibold text-sm"
                    style={{ color: secondaryColor || "#E3007B" }}
                  >
                    Web Check-In
                  </span>
                </AppStandardButton>
              )}
          {showResPrintButton && (
            <AppStandardButton
              onClick={() => {
                BookingApi.getResPrint(ResId?.split("-")[2] || "", lang).then(
                  (e) => {
                    const url = (e as any)?.file;
                    const linkSource = `data:application/pdf;base64,${url}`;
                    const downloadLink = document.createElement("a");
                    const fileName = "file.pdf";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                  }
                );
              }}
              variant="outlined"
              className="flex-1 py-4"
              style={{
                borderRadius: "10px",
                borderColor: primaryColor || "#22c55e",
                textTransform: "none",
              }}
            >
              <span
                className="normal-case font-semibold text-sm whitespace-nowrap"
                style={{ color: secondaryColor }}
              >
                Print Reservation
              </span>
            </AppStandardButton>
          )}
        </div>
      </div>

      {/* Discover experiences (optional, below card) */}
      {appSettings?.showDiscoverExpThankYou && (
        <div className="flex flex-col items-center gap-3 mt-6">
          <p
            className="text-base font-semibold text-center"
            style={{ color: secondaryColor }}
          >
            {showDiscoverThankText}
          </p>
          <AppStandardButton
            href="https://brevetermine.viaggiarerent.com/promo/civitatis/"
            variant="outlined"
            className="px-6 py-2"
            style={{
              borderRadius: "10px",
              borderColor: primaryColor,
            }}
          >
            <span
              className="normal-case text-sm"
              style={{ color: secondaryColor }}
            >
              {discoverButtonText}
            </span>
          </AppStandardButton>
        </div>
      )}
    </section>
  );
}
